<header>
  <app-navbar></app-navbar>

  <!--  <div class="text-center bg-image" alt="Wild Landscape" style="-->
  <!--        background-image: url('assets/img/header_cover.webp');-->
  <!--        height: 95vh;-->
  <!--        margin-top: 40px;-->
  <!--      ">-->
  <div class="header-content mt-4">
    <div class="container">
      <div class="row gx-5">
        <div class="col slider-content">
          <!-- <video playsinline autoplay muted loop class="video-background" id="bgvid">
          <source src="https://gtngroup.com/wp-content/uploads/2023/05/Header-video-V5.mp4" type="video/mp4">
        </video>
        <div class="d-flex justify-content-center align-items-center h-100 bg-video-text">
          <div class="text-white header-content  w-100">
            <div *ngIf="userType === 'OMS'">
              <div class="text-center text-lg-start">
                <h4 class="sub-heading mb-4">
                  Powering access to global financial assets for
                  <b class="dynamic-word">{{ dynamicWord }}</b>
                </h4>
              </div>
            </div>
            <div *ngIf="userType === 'FEED'">
              <h1 class="heading mb-3">GTN Market Data Feed Developer Portal</h1>
              <h4 class="sub-heading mb-4">
                Easy way to integrate with our GTN Market Data Infrastructure
              </h4>
            </div>
          </div>
        </div> -->
          <div>
            <div class="d-flex align-items-center">
              <div class="container px-0">
                <div class=" row banner-section">
                  <div class="col-12 col-lg-6 order-2 order-lg-1">
                    <h3>One API framework <br />
                      to realise your vision</h3>
                    <p class="sub-heading mb-4 mt-4">
                      Building blocks for embedded trading and wealth user experiences that are fast, flexible, and
                      ready
                      to
                      scale. Access our Developer Portal to see how our API services can help you get there.
                      <!-- <b class="dynamic-word">{{ dynamicWord }}</b> -->
                    </p>
                    <a href="/registration" (click)="openRegistration($event)" class="get-access" type="button" *ngIf="!isLoggedIn">Get Started</a>
                  </div>
                  <div class="col-12 col-lg-6 order-1 order-lg-2 text-center mb-4 mb-lg-0">
                    <img src="./assets/img/main-banner.png" class="card-banner" alt="Trade APIs" />
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>